$(document).ready(function() {
  const IMAGESPATH = "/wp-content/themes/new-ces/img/marcas/";
  function getLogoBrand(brand_name) {
    brand_name = brand_name.replace(/\s/g, "-");
    brand_name = brand_name.toLowerCase();
    return IMAGESPATH + brand_name + "-color.png";
  }
  let allPosts = [];
  let countCards = 0;

  function loadPosts(typePost, containerResults, pageNumber = null) {
    switch (typePost) {
      case "new":
        var action = "more_post_ajax";
        var template = wp.template("car-card");
        break;
      case "used":
        var action = "more_post_used_ajax";
        var template = wp.template("used-car-card");
        break;
      case "machinery":
        var action = "more_post_machinery_ajax";
        var template = wp.template("machinery-card");
        break;
    }

    /**Get params of filter */
    const params = ajax_filter_params.query_params;
    console.log(params);

    // Manejar car_class
    if (Array.isArray(params.car_class)) {
      // Si es un array, convertirlo a string uniendo con '+'
      params.car_class = params.car_class.join("+");
    } else if (params.car_class == "todos") {
      params.car_class = "";
    } else if (
      typeof params.car_class === "string" &&
      params.car_class !== "todos" &&
      params.car_class !== ""
    ) {
      // Ya es un string con un valor válido, no hacer nada
      // Esto asegura que valores como "camioneta" se mantengan como están
    }

    // Manejar car_model_slug
    if (Array.isArray(params.car_model_slug)) {
      params.car_model_slug = params.car_model_slug.join("+");
    } else if (params.car_model_slug == "todos") {
      params.car_model_slug = "";
    }

    // Manejar otros parámetros
    params.car_combustible =
      params.car_combustible == "todos" ? "" : params.car_combustible;
    params.car_transmision =
      params.car_transmision == "todos" ? "" : params.car_transmision;
    params._ceswp_transmission =
      params._ceswp_transmission == "todos"
        ? "todos"
        : params._ceswp_transmission;

    /**distintos casos para reparar var params.brand_name*/
    if (params.brand_name == "todos") {
      params.brand_name = "";
    } else if (Array.isArray(params.brand_name)) {
      // Si es un array, convertirlo a string uniendo con '+'
      params.brand_name = params.brand_name.join("+");
    } else if (
      typeof params.brand_name === "string" &&
      params.brand_name.search("\\+") != -1
    ) {
      // Ya es un string con formato adecuado
      params.brand_name = params.brand_name;
    }

    $("#loading").show();

    if (searchPosts) {
      // Construir datos para la petición AJAX
      let ajaxData = {
        pageNumber: pageNumber,
        action: action,
        car_order: params.car_order || "asc",
        price_min: params.price_min || "1000000",
        price_max: params.price_max || "60000000",
        special_sale: params.special_sale || "todos",
      };

      // Añadir car_class
      if (params.car_class && params.car_class !== "") {
        ajaxData.car_class = params.car_class;
      }

      // Añadir brand_name
      if (params.brand_name && params.brand_name !== "") {
        ajaxData.brand_name = params.brand_name;
      }

      // Añadir car_model_slug
      if (params.car_model_slug && params.car_model_slug !== "") {
        ajaxData.car_model_slug = params.car_model_slug;
      }

      // Añadir otros parámetros solo si tienen valor
      if (params.featured && params.featured !== "")
        ajaxData.featured = params.featured;
      if (params.car_year && params.car_year !== "")
        ajaxData.car_year = params.car_year;
      if (params.ids && params.ids !== "") ajaxData.ids = params.ids;
      if (params.car_combustible && params.car_combustible !== "")
        ajaxData.car_combustible = params.car_combustible;
      if (params.car_transmision && params.car_transmision !== "")
        ajaxData.car_transmision = params.car_transmision;
      if (params._ceswp_transmission && params._ceswp_transmission !== "")
        ajaxData._ceswp_transmission = params._ceswp_transmission;

      console.log("Enviando datos AJAX:", ajaxData);

      $.ajax({
        type: "GET",
        url: ajax_filter_params.ajax_url,
        dataType: "json",
        data: ajaxData,
        success: function(data) {
          console.log("AJAX response 1:", data);
          console.log("Request params:", ajaxData);
          if (data.posts && data.posts.length && Array.isArray(data.posts)) {
            $("#number_posts").html(data.found_posts);
            $("#number_posts_filter").html(data.found_posts);
            if (typePost !== "new") {
              $(".cont-search-used").removeClass("d-none");
              sortedBy(true);
            } else {
              $(".cont-search").removeClass("d-none");
            }

            allPosts = data.posts;
            printResults(
              allPosts,
              containerResults,
              template,
              typePost,
              data.found_posts,
              false
            );

            $("#loading").hide();
          } else {
            $(".no-results").removeClass("d-none");
            $("#loading").hide();
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          $("#loading h5").html("No se encontraron resultados.");
          $("#loading img")
            .removeClass("d-block")
            .addClass("d-none");
          $("#loading").hide();
          console.log("Error en la petición AJAX:", textStatus, errorThrown);
        },
      });
    }
    return false;
  }

  /**Container page-search-news*/
  let loadingInfiniteScroll = false;
  if ($("#posts").length) {
    var searchPosts = true;
    loadPosts("new", $("#posts"));

    const offset = window.innerWidth < 475 ? 1077 : 300;
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - offset;

      if (bottomOfWindow) {
        if (!loadingInfiniteScroll) {
          loadingInfiniteScroll = false;
          printResults(
            allPosts,
            $("#posts"),
            wp.template("car-card"),
            "new",
            allPosts.length,
            true
          );
          loadingInfiniteScroll = true;
        }
      }
    };
  }

  /**Container page-search-used*/
  if ($("#used-cars").length) {
    var searchPosts = true;
    var page_number = 1;
    loadPosts("used", $("#used-cars"), page_number);

    let loadingInfiniteScroll = false;
    const offset = window.innerWidth < 475 ? 1077 : 300;
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - offset;

      if (bottomOfWindow) {
        if (!loadingInfiniteScroll) {
          loadingInfiniteScroll = true;
          page_number++;
          loadPosts("used", $("#used-cars"), page_number);
        }
      }
    };
  }

  /**Order of post used */
  function sortedBy(asc) {
    $divs = $(".grid-item");
    var numericallyOrderedDivs = $divs.sort(function(a, b) {
      var vA = $(a)
        .find(".item-used-card")
        .data("price");
      var vB = $(b)
        .find(".item-used-card")
        .data("price");
      return (vA < vB ? -1 : vA > vB ? 1 : 0) * (asc ? -1 : 1);
    });
    var postDiv = $("#used-cars");
    postDiv.html(numericallyOrderedDivs);
  }

  /**Button order in used */
  $(".order-grid").on("click", function(e) {
    var asc = $(this).hasClass("asc");
    sortedBy(asc);

    $(this).addClass("active");

    $(".order-grid")
      .not(this)
      .each(function() {
        $(this).removeClass("active");
      });
  });

  /**Function printResults */
  function printResults(
    posts,
    containerResults,
    template,
    typePost,
    totalPosts = 0,
    load
  ) {
    if (typePost === "new") {
      let arrayData = [];
      if (load) {
        let arrayMoreVersions = posts.slice(9, allPosts.length);
        arrayData = arrayData.concat(arrayMoreVersions);
      } else {
        let arrayVersions = posts.slice(0, 9);
        arrayData = arrayData.concat(arrayVersions);
        //console.log(arrayData)
      }

      arrayData.forEach(function(post_meta) {
        post_meta._ceswp_brand_img = post_meta._ceswp_brand_name
          ? getLogoBrand(post_meta._ceswp_brand_name)
          : "/wp-content/themes/new-ces/img/loading.svg";
        post_meta._ceswp_public_price =
          post_meta._ceswp_price_min || "Sin información";
        post_meta._ceswp_price_bonus_amicar_render =
          post_meta._ceswp_price_bonus_brand - post_meta._ceswp_price_amicar;
        post_meta._ceswp_price_bonus_brand_render =
          post_meta._ceswp_price_list - post_meta._ceswp_price_bonus_brand;

        render = template(post_meta);
        containerResults.append(
          '<div class="col-12 col-md-6 col-lg-4 grid-item">' + render + "</div>"
        );
        Waypoint.refreshAll();
      });

      /**Button compare */
      containerResults.find(".compare-from-card").each(function() {
        this.onclick = function() {
          this.disabled = true;
          toggleCarFromComparator(this.dataset.id);
        };
      });
      containerResults.find(".button-compare").each(function() {
        this.onclick = function() {
          goToComparator();
        };
      });
      // Updates the comparator button status (comparator.js)
      if (typeof updateComponents === "function") {
        containerResults.find(".compare-from-card").each(function() {
          this.onclick = function() {
            this.disabled = true;
            toggleCarFromComparator(this.dataset.id);
          };
        });
        updateComponents();
      }

      //Count Posts for cards
      let containerPost = document.querySelector("#posts");
      let cards = containerPost.querySelectorAll(".grid-item");
      countCards = cards.length;
    } else {
      /**Autos usados */
      posts.forEach(function(post_meta) {
        post_meta._ceswp_brand_img = post_meta._ceswp_brand_name
          ? getLogoBrand(post_meta._ceswp_brand_name)
          : "/wp-content/themes/new-ces/img/loading.svg";
        post_meta._ceswp_public_price =
          post_meta._ceswp_price_min || "Sin información";
        post_meta._ceswp_price_bonus_amicar_render =
          post_meta._ceswp_price_bonus_brand - post_meta._ceswp_price_amicar;
        post_meta._ceswp_price_bonus_brand_render =
          post_meta._ceswp_price_list - post_meta._ceswp_price_bonus_brand;

        render = template(post_meta);
        containerResults.append(
          '<div class="col-12 col-md-6 col-lg-4 grid-item">' + render + "</div>"
        );
        Waypoint.refreshAll();
      });
    }
  }

  /**Function infinite scroll loadPosts */
  /* scroll(9, null)
  function scroll( versionsToShow, filteredVersions ) {
    
  } */

  /* let loadingInfiniteScroll = false
  const offset = window.innerWidth < 475 ? 1077 : 300
  window.onscroll = () => {
    let bottomOfWindow =
      document.documentElement.scrollTop + window.innerHeight >=
      document.documentElement.offsetHeight - offset

    if (bottomOfWindow) {
      if (!loadingInfiniteScroll) {
        loadingInfiniteScroll = true          
        loadMorePosts( 9, filteredVersions )
      }
    }
  } */

  /**Function loadMorePosts */
  /* function loadMorePosts( versionsToShow, filteredVersions null ) {
    let versionsToShowNewValue = versionsToShow + 9
    if (versionsToShowNewValue < filteredVersions.length) {
      versionsToShow = versionsToShowNewValue
    } else {
      versionsToShow = filteredVersions.length
    }
    loadingInfiniteScroll = false
  } */
});
